import { eManulSortLayerDrawOrder, Game } from "../../../Game";
import { ModelUtils } from "../../../Utils/Models/ModelUtils";
import { PlaneMesh } from "../../../Utils/Models/PlaneMesh";
import { AtlasUtils } from "../../../Utils/Atlas/AtlasUtils";



/**
 * Entity pro jeden snimek
 */
export class DecoFrameEnts {
    get entities(): pc.Entity[] { return this._entities; }
    private _entities: pc.Entity[];

    private _undegroundY: number;

    get enabled(): boolean { return this._enabled; }
    set enabled(val: boolean) {
        if (this._enabled != val) {
            this._enabled = val;
            this._entities.forEach((entity: pc.Entity): void => { entity.enabled = val; });
        }
    }
    private _enabled: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(frameKey: string, entityCnt: number, material: pc.StandardMaterial, container: pc.GraphNode, batchGroupId: number, pixelsPerUnit: number, rotation: pc.Vec3) {
        // Vytvorit model pro entity
        let atlas = Game.atlas;
        let frame = atlas.frames[frameKey] as pc.TextureAtlasFrame;
        let frameRect = frame.rect;
        let frameW = frameRect.z / pixelsPerUnit;
        let frameH = frameRect.w / pixelsPerUnit;
        let framePivot = frame.pivot;

        this._undegroundY = -frameH * (1 - framePivot.y);

        let mesh = PlaneMesh.createMesh(Game.app.graphicsDevice, new pc.Vec4(-frameW * framePivot.x, -frameH * framePivot.y, frameW * (1 - framePivot.x), frameH * (1 - framePivot.y)), AtlasUtils.getTexFrameRegion(atlas.texture, frameRect));
        let model = ModelUtils.createModel([mesh], material);

        // Vytvorit entity
        this._entities = [];

        while (entityCnt-- != 0) {
            let entity = new pc.Entity();

            entity.addComponent(pc.eCompomentType.model, {
                type: pc.eModelType.asset,
                castShadows: false,
                receiveShadows: false,
                batchGroupId: batchGroupId
            });
            entity.model.model = (entityCnt == 0 ? model : model.clone());
            entity.setLocalPosition(0, this._undegroundY, 0);     // Umistit pod zem

            container.addChild(entity);
            this._entities.push(entity);
        }

        this._enabled = true;
    }

    //-------------------------------------------------------------------------
    /**
     * Premisteni entit na nove pozice. Entity, pro ktere pozice neni se presunou pod zem, tak aby nebyli videt (nedojde k jejich zakazani, protoze by se musel prestavet batch)
     * @param positions Pole s pozicemi pro umisteni entit
     */
    //-------------------------------------------------------------------------
    repositionEntities(positions: pc.Vec3[]): void {
        // Premistit entity
        positions.forEach((pos: pc.Vec3, id: number): void => {
            this._entities[id].setLocalPosition(pos);
        });

        // Pozice, ktere jsou navic, presunout pod uroven zeme, aby nebyly videt
        let id = positions.length;

        while (id < this._entities.length) {
            this._entities[id++].setLocalPosition(0, this._undegroundY, 0);
        }
    }
}
